import React, { useEffect, useState } from 'react';
import SupervisorLayout from '../../components/SupervisorLayout';
import { fetchSupervisorTicketDetail, searchSupervisorVerifyTickets } from '../../api/supervisor';
import TicketViewModal from '../../components/TicketViewModal';
import './SupervisorBankTicketsView.css';

const sortTickets = (rows) => [...rows].sort((a, b) => {
  if (a.no !== b.no) return (a.no ?? 0) - (b.no ?? 0);
  return a.tirage_code - b.tirage_code;
});

// `bank` = la ligne deja chargee par SupervisorBanquesConnecteResults (id, name,
// phone, ...) — pas de nouvel appel "get one bank" cote backend (l'adresse
// n'est donc pas disponible ici, comme BankMonitoringView ne la renvoie pas).
const SupervisorBankTicketsView = ({ bank, date, onBack }) => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  // Fiche ouverte (clic sur une ligne) : boules jouees, gains... (2026-10-11).
  const [openTicketId, setOpenTicketId] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    searchSupervisorVerifyTickets({ bank: bank.id, date })
      .then((data) => { if (!cancelled) setTickets(sortTickets(data)); })
      .catch(() => { if (!cancelled) setError('Impossible de charger les tickets — verifie que le serveur backend tourne.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [bank.id, date]);

  const utilisateur = tickets.find((t) => t.device_serial)?.device_serial || '';

  return (
    <SupervisorLayout>
      <button className="svbtv-back-btn" onClick={onBack}>Arriere</button>

      <div className="svbtv-card">
        <div className="svbtv-card-header">
          <span className="svbtv-card-title">Tickets per la Banque</span>
        </div>

        <div className="svbtv-info">
          <div className="svbtv-info-row">
            <span className="svbtv-info-label">Banque:</span>
            <span className="svbtv-info-box">{bank.seq} - {bank.name}</span>
          </div>
          <div className="svbtv-info-row">
            <span className="svbtv-info-label">Telephone :</span>
            <span className="svbtv-info-box svbtv-info-box-wide">{bank.phone || '.'}</span>
          </div>
          <div className="svbtv-info-row">
            <span className="svbtv-info-label">Utilisateur :</span>
            <span className="svbtv-info-box svbtv-info-box-wide">{utilisateur}</span>
          </div>
        </div>

        <div className="svbtv-table-bar"></div>

        {error && <p className="svbtv-error">{error}</p>}
        {loading && <p className="svbtv-loading">Chargement...</p>}

        {!loading && !error && (
          <table className="svbtv-table">
            <thead>
              <tr>
                <th>Sec.</th>
                <th>Loterie</th>
                <th>Sales Type</th>
                <th>Numero de Ticket</th>
                <th>Montant</th>
                <th>Temp</th>
              </tr>
            </thead>
            <tbody>
              {tickets.map((row) => (
                <tr
                  key={row.id}
                  className="tvm-clickable-row"
                  title="Voir les boules jouees"
                  onClick={() => setOpenTicketId(row.id)}
                >
                  <td>{row.sq ?? '-'}</td>
                  <td>{row.tirage_name} | ( {row.tirage_code} )</td>
                  <td>{row.was_offline ? 'Local' : 'OnLine'}</td>
                  <td><span className="svbtv-numero">{row.no ?? '-'}</span></td>
                  <td>{Number(row.total_amount).toFixed(2)}</td>
                  <td>{new Date(row.created_at).toLocaleTimeString()}</td>
                </tr>
              ))}
              {tickets.length === 0 && (
                <tr><td colSpan={6} className="svbtv-empty">Aucun ticket trouvé.</td></tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      {openTicketId != null && (
        <TicketViewModal
          ticketId={openTicketId}
          fetcher={fetchSupervisorTicketDetail}
          onClose={() => setOpenTicketId(null)}
        />
      )}
    </SupervisorLayout>
  );
};

export default SupervisorBankTicketsView;
